import { render, staticRenderFns } from "./AtopicDermatitisScoresPhase.vue?vue&type=template&id=43e2b909&scoped=true&"
import script from "./AtopicDermatitisScoresPhase.vue?vue&type=script&lang=js&"
export * from "./AtopicDermatitisScoresPhase.vue?vue&type=script&lang=js&"
import style0 from "./AtopicDermatitisScoresPhase.vue?vue&type=style&index=0&id=43e2b909&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e2b909",
  null
  
)

export default component.exports